/*
 * @ author Steven Jang <steven@nurigo.net>
 */
const PW_REGEX = /^(?=.*?[a-zA-Z])(?=.*?[0-9])(?=.*?[~!@#$%^&*()_+[\]\-={}|?<>/\\"'.,`₩:;])[a-zA-Z0-9~!@#$%^&*()_+[\]\-={}|?<>/\\"'.,`₩:;]{6,16}$/
const NM_REGEX = /^[가-힣a-zA-Z0-9\s]{2,20}$/
export default { PW_REGEX, NM_REGEX }
